export const FeesPages = {
	AriseFee: {
		name: "arise-fee",
		displayName: "ARISE Fee Templates",
	},
	AriseFeeAdd: {
		name: "add-arise-fee-template",
		displayName: "Add ARISE Fee Template",
	},
	AriseFeeEdit: {
		name: "edit-arise-fee-template",
		displayName: "Edit ARISE Fee Template",
	},
	AchFee: {
		name: "ach-fee",
		displayName: "ACH Fee Templates",
	},
	AchFeeAdd: {
		name: "add-ach-fee-template",
		displayName: "Add ACH Fee Template",
	},
	AchFeeEdit: {
		name: "edit-ach-fee-template",
		displayName: "Edit ACH Fee Template",
	},
};
